module.exports = __webpack_public_path__ + "img/fresh-air.dde9d9ff.svg";